import { CardSkeleton } from "@/ui/card-skeleton";

export const CommentCardSkeleton = () => {
  return <CardSkeleton withAvatar />;
};
